import React from 'react';
import styles from './styles.module.scss';
import { LANDING_PAGE_DATA } from '../config';
import Carousal from '../common/StaticCarousal';
import CustomerTestimonial from '../common/TestimonialCard';

const Index = () => {
  const { testimonial_section } = LANDING_PAGE_DATA;

  return (
    <section className={styles.testimonialsSection}>
      <div>
        <div className={styles.sectionTitle} style={{ marginBottom: 'unset' }}>
          {testimonial_section.title}{' '}
          <span className={styles.customerSupportHighlight}>
            {testimonial_section.colored_text}
          </span>
        </div>
      </div>
      <Carousal
        Component={CustomerTestimonial}
        list={LANDING_PAGE_DATA.testimonial_section?.customer_list}
      />
    </section>
  );
};

export default Index;
